import React, { useState } from 'react';
import { Outlet, Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
// import { FaHome, FaUser, FaHistory, FaSignOutAlt, FaChartLine, FaUsers, FaMoneyBillWave, FaBook, FaCommentDots, FaBell, FaSearch, FaBars, FaTimes, FaTruck } from 'react-icons/fa';
import {
    FiHome, FiBook, FiUser, FiCreditCard, FiBarChart2,
    FiUsers, FiLogOut, FiMenu, FiSettings, FiShield, FiActivity, FiMessageSquare, FiCalendar, FiTruck
} from 'react-icons/fi';
export default function DashboardLayout() {
    const { currentUser, logout } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();
    const [sidebarOpen, setSidebarOpen] = useState(false);

    const handleLogout = () => {
        logout();
        navigate('/');
    };

    const isActive = (path) => {
        return location.pathname === path || location.pathname.startsWith(`${path}/`);
    };

    // Define navigation based on role
    const getNavItems = () => {
        if (currentUser?.role === 'admin') {
            return [
                { name: 'Dashboard', path: '/dashboard', icon: <FiHome />, badge: null },
                { name: 'Users', path: '/dashboard/users', icon: <FiUsers />, badge: null },
                { name: 'Teachers', path: '/dashboard/admin/teachers', icon: <FiUser />, badge: null },
                { name: 'Classes', path: '/dashboard/admin/classes', icon: <FiBook />, badge: null },
                { name: 'Payments', path: '/dashboard/payments', icon: <FiCreditCard />, badge: 'Active' },
                { name: 'Delivery', path: '/dashboard/admin/delivery', icon: <FiTruck />, badge: null },
                { name: 'Results', path: '/dashboard/marks', icon: <FiBarChart2 />, badge: null },
                { name: 'Evaluation', path: '/dashboard/admin/evaluation', icon: <FiActivity />, badge: 'New' },
                { name: 'Feedback', path: '/dashboard/admin/feedback', icon: <FiMessageSquare />, badge: null },
                { name: 'Attendance', path: '/dashboard/admin/attendance', icon: <FiCalendar />, badge: 'Live' },
                { name: 'Security', path: '/dashboard/admin/settings', icon: <FiShield />, badge: null },
                { name: 'History', path: '/dashboard/admin/history', icon: <FiActivity />, badge: null },
                { name: 'Profile', path: '/dashboard/profile', icon: <FiSettings />, badge: null },
            ];
        } else if (currentUser?.role === 'student') {
            return [
                { name: 'Home', path: '/dashboard', icon: <FiHome />, badge: null },
                { name: 'My Courses', path: '/dashboard/courses', icon: <FiBook />, badge: '3' },
                { name: 'Payments', path: '/dashboard/payments', icon: <FiCreditCard />, badge: 'Due' },
                { name: 'Results', path: '/dashboard/marks', icon: <FiBarChart2 />, badge: null },
                { name: 'Attendance', path: '/dashboard/student/attendance', icon: <FiCalendar />, badge: null },
                { name: 'Profile', path: '/dashboard/profile', icon: <FiUser />, badge: null },
            ];
        } else {
            return [
                { name: 'Dashboard', path: '/dashboard', icon: <FiHome /> },
                { name: 'Marks', path: '/dashboard/marks', icon: <FiBarChart2 /> },
                { name: 'Profile', path: '/dashboard/profile', icon: <FiUser /> },
            ];
        }
    };

    const navItems = getNavItems();

    return (
        <div className="flex h-screen bg-[#F4F5F7] font-sans">
            {/* Mobile Sidebar Overlay */}
            {sidebarOpen && (
                <div
                    className="fixed inset-0 z-40 bg-black/20 backdrop-blur-sm lg:hidden"
                    onClick={() => setSidebarOpen(false)}
                ></div>
            )}

            {/* Sidebar */}
            <div
                className={`fixed inset-y-0 left-0 z-50 w-72 bg-white shadow-2xl lg:shadow-none transform transition-transform duration-300 ease-in-out lg:translate-x-0 lg:static lg:inset-auto border-r border-gray-100 flex flex-col ${sidebarOpen ? 'translate-x-0' : '-translate-x-full'
                    }`}
            >
                {/* Header / Logo */}
                <div className="h-20 flex items-center px-8">
                    {/* Replicating the "Mac window dots" look if desired, or just clean logo */}
                    <div className="flex items-center gap-2">
                        <div className="w-3 h-3 rounded-full bg-red-400"></div>
                        <div className="w-3 h-3 rounded-full bg-yellow-400"></div>
                        <div className="w-3 h-3 rounded-full bg-green-400"></div>
                    </div>
                    <span className="ml-4 text-lg font-bold text-gray-800 tracking-tight font-display">SudeshMaths</span>
                </div>


                {/* Navigation Scroll Area */}
                <div className="flex-1 overflow-y-auto px-4 space-y-8">

                    {/* Main Menu */}
                    <nav className="space-y-1">
                        {navItems.map((item) => {
                            const active = isActive(item.path);
                            return (
                                <Link
                                    key={item.path}
                                    to={item.path}
                                    onClick={() => setSidebarOpen(false)}
                                    className={`relative flex items-center justify-between px-4 py-3.5 text-sm font-medium rounded-xl transition-all duration-200 group ${active
                                        ? 'text-blue-600'
                                        : 'text-gray-500 hover:bg-gray-50 hover:text-gray-900'
                                        }`}
                                >
                                    {/* Active Left Border Indicator */}
                                    {active && (
                                        <div className="absolute left-0 top-1/2 -translate-y-1/2 w-1 h-8 bg-blue-600 rounded-r-md"></div>
                                    )}

                                    <div className="flex items-center gap-4">
                                        <span className={`text-lg transition-colors ${active ? 'text-blue-600' : 'text-gray-400 group-hover:text-gray-600'}`}>
                                            {item.icon}
                                        </span>
                                        <span>{item.name}</span>
                                    </div>

                                    {/* Badge */}
                                    {item.badge && (
                                        <span className={`px-2 py-0.5 text-xs font-bold rounded-md ${active ? 'bg-blue-600 text-white' : 'bg-gray-100 text-gray-600'
                                            }`}>
                                            {item.badge}
                                        </span>
                                    )}
                                </Link>
                            );
                        })}
                    </nav>

                    {/* Categories Section (Visual mimicry of the design) */}
                    {/* <div>
                        <div className="flex items-center justify-between px-4 mb-4 text-xs font-bold text-gray-400 uppercase tracking-wider">
                            <span>Categories</span>
                            <FiGrid />
                        </div>
                        <div className="space-y-1">
                            {['Academic', 'Financial', 'Reports'].map((cat, idx) => (
                                <button key={cat} className="w-full flex items-center justify-between px-4 py-2 text-sm text-gray-500 hover:text-gray-900 hover:bg-gray-50 rounded-lg transition-colors group">
                                    <div className="flex items-center gap-3">
                                        <span className={`w-2 h-2 rounded-full ${idx === 0 ? 'bg-green-400' : idx === 1 ? 'bg-red-400' : 'bg-blue-400'
                                            }`}></span>
                                        <span>{cat}</span>
                                    </div>
                                    <span className="text-xs text-gray-400 group-hover:text-gray-600 font-medium">
                                        {12 + idx * 5}
                                    </span>
                                </button>
                            ))}
                        </div>
                    </div> */}
                </div>

                {/* Footer / Profile Section */}
                <div className="p-4 border-t border-gray-50">
                    <div className="flex items-center justify-between px-2 mb-2">
                        <span className="text-xs font-bold text-gray-400 uppercase tracking-wider">User</span>
                    </div>
                    <div className="flex items-center gap-3 p-2 rounded-xl hover:bg-gray-50 transition-colors cursor-pointer group">
                        <div className="w-10 h-10 rounded-full bg-gradient-to-tr from-blue-500 to-indigo-600 flex items-center justify-center text-white font-bold shadow-md shadow-blue-200">
                            {currentUser?.name?.charAt(0) || 'U'}
                        </div>
                        <div className="flex-1 overflow-hidden">
                            <h4 className="text-sm font-bold text-gray-900 truncate">{currentUser?.name}</h4>
                            <p className="text-xs text-blue-500 font-medium capitalize">{currentUser?.role}</p>
                        </div>
                        <button onClick={handleLogout} className="p-2 text-gray-400 hover:text-red-500 transition-colors">
                            <FiLogOut size={18} />
                        </button>
                    </div>
                </div>
            </div>

            {/* Main Content Area */}
            <div className="flex-1 flex flex-col overflow-hidden bg-[#F4F5F7] relative">

                {/* Mobile Header */}
                <header className="flex items-center justify-between h-16 px-6 bg-white border-b border-gray-100 lg:hidden shadow-sm sticky top-0 z-30">
                    <button
                        onClick={() => setSidebarOpen(true)}
                        className="text-gray-500 hover:text-gray-700 focus:outline-none p-2"
                    >
                        <FiMenu size={24} />
                    </button>
                    <span className="text-lg font-bold text-gray-900">Dashboard</span>
                    <div className="w-10"></div>
                </header>

                {/* Content */}
                <main className="flex-1 overflow-x-hidden overflow-y-auto p-6 md:p-8">
                    <div className="max-w-7xl mx-auto">
                        <Outlet />
                    </div>
                </main>
            </div>
        </div>
    );
}
